import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

const styles = (theme) => ({
  root: {
    paddingTop: 20,
    alignContent: 'flex-end',
  },
  MuiFormControlRoot: {
    display: 'flex',
    '& label': {
      fontSize: 12,
    },
  },
  MuiButtonLabel: {
    fontSize: 15,
  },
  addToCartButton: {
    '&.disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
    marginTop: 10,
  },
  captionTypography: {
    display: 'block',
  },
  buttonPriceList: {
    textTransform: 'none',
    position: 'absolute',
    bottom: 90,
    fontSize: 15,
    right: 200,
    color: theme.palette.primary.main,
    [theme.breakpoints.down('xs')]: {
      left: 15,
      whiteSpace: 'nowrap',
    },
  },
});

class AddToCart extends React.Component {
  static propTypes = {
    amount: PropTypes.number,
    disabled: PropTypes.bool,
    onPress: PropTypes.func,
    buttonLabel: PropTypes.string,
    noteLabel: PropTypes.string,
    classes: PropTypes.object,
    handleChange: PropTypes.func,
    note: PropTypes.string,
    hidePrices: PropTypes.bool,
    totalPrice: PropTypes.string,
    taxNote: PropTypes.string,
    showReceiveOfferForm: PropTypes.bool,
    priceListClick: PropTypes.func,
    showPriceList: PropTypes.bool,
    priceListLabel: PropTypes.string,
    showCallToAction: PropTypes.bool,
    onAddMoreConfigurationClick: PropTypes.func,
  };
  render() {
    const {
      amount,
      disabled,
      onPress,
      buttonLabel,
      noteLabel,
      classes,
      handleChange,
      note,
      hidePrices,
      totalPrice,
      taxNote,
      showPriceList,
      priceListLabel,
      priceListClick,
      showCallToAction,
      onAddMoreConfigurationClick,
    } = this.props;
    const disabledClassName = disabled ? 'disabled' : '';
    const className = [disabledClassName].join(' ');

    return (
      <Grid item xs={12} className={classes.root}>
        {amount > 0 && !hidePrices && (
          <React.Fragment>
            {showPriceList && (
              <Button onClick={priceListClick} className={classes.buttonPriceList}>
                {priceListLabel}
              </Button>
            )}
            <Typography
              variant="h5"
              align="right"
              classes={{
                h5: classes.MuiTypographyRoot,
              }}
            >
              <b>{totalPrice}</b>
            </Typography>
            <Typography
              variant="caption"
              classes={{
                caption: classes.captionTypography,
              }}
              gutterBottom={true}
              align="right"
            >
              <i>{taxNote}</i>
            </Typography>
          </React.Fragment>
        )}
        {note && (
          <TextField
            label={noteLabel}
            multiline
            rows="3"
            rowsMax="8"
            value={note}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
            classes={{
              root: classes.MuiFormControlRoot,
            }}
          />
        )}
        {showCallToAction && (
          <>
            <AnalyticsWrapper targetId="selected_amounts">
              <MainButton
                variant="contained"
                size="large"
                className={className + ' ' + classes.MuiButtonLabel + ' ' + classes.addToCartButton}
                onClick={disabled ? null : onPress}
                fullWidth
              >
                {buttonLabel}
              </MainButton>
            </AnalyticsWrapper>
            <AnalyticsWrapper targetId="selected_amounts">
              <MainButton
                variant="contained"
                size="large"
                className={className + ' ' + classes.MuiButtonLabel + ' ' + classes.addToCartButton}
                onClick={onAddMoreConfigurationClick}
                fullWidth
              >
                {t('receiveOfferForm.addMoreConfigurations')}
              </MainButton>
            </AnalyticsWrapper>
          </>
        )}
      </Grid>
    );
  }
}

export default withStyles(styles, { name: 'AddToCart' })(AddToCart);
